module.exports = __webpack_public_path__ + "static/overlay-imported-content-do-7120c9949dcbbf1e6cf2080066648764.png";